import { render, staticRenderFns } from "./AboutUsPage.vue?vue&type=template&id=b1352500&scoped=true&"
import script from "./AboutUsPage.vue?vue&type=script&lang=js&"
export * from "./AboutUsPage.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPage.vue?vue&type=style&index=0&id=b1352500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1352500",
  null
  
)

export default component.exports